import { render, staticRenderFns } from "./MajorMaintenanceEdit.vue?vue&type=template&id=2f6ce5a6"
import script from "./MajorMaintenanceEdit.vue?vue&type=script&lang=js"
export * from "./MajorMaintenanceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports